import { MgsaTabsEnum } from '@/modules/learner/views/TeamDashboard/widgets/TeamMgsaWidget/types';

import { learnerRoutes as okrLearnerRoutes } from './okr';

const routes = {
  Home: () => '/home',
  DiscoverRoot: () => '/discover',
  Discover: (widgetId: string) => `/discover/${widgetId}`,
  Search: () => '/results',
  TeamDashboard: (options?: { isProductivityModelEnabled?: boolean; userId?: string }) =>
    options?.isProductivityModelEnabled && options.userId
      ? `/w/profile/${options.userId}/team`
      : '/team',
  TeamDashboardMulti: (mgsaTab: MgsaTabsEnum) => `/team?mgsa-tab=${mgsaTab}`,
  LearnerProfile: (learnerId: string) => `/learners/${learnerId}`,
  LearnerReports: () => '/reports',
  LearnerIntegrations: () => '/integrations',
  LearnerIntegrationsDetails: (integrationId: string) => `/integrations/${integrationId}/details`,
  LearnerIntegrationsSettings: (integrationId: string) => `/integrations/${integrationId}/settings`,
  LearnerReportViewer: (reportId: string) => `/reports/${reportId}/view`,
  ToReview: () => '/to-review',
  ...okrLearnerRoutes,
};

export default routes;
